export default "__VITE_ASSET__CLI3BX$x__"